import React from "react";
import { Link } from "react-router-dom";
import PricingTableData from "../Data/PricingTableData.json";

const PricingTable = () => {
  return (
    <>
      <section className="pricing-area">
        <div className="container">
          <div className="row">
            {PricingTableData.map((SinglePricing) => (
              <div className="col-lg-4 col-md-6 col-12" key={SinglePricing.id}>
                <div className={SinglePricing.singleclass}>
                  <div className={SinglePricing.mostpopular}>
                    <h4>Most Popular</h4>
                  </div>
                  <div className="pricing-head">
                    <h2 className="p-title">{SinglePricing.title}</h2>
                  </div>
                  <div className="pricing-price">
                    <h4 className="amount-s">{SinglePricing.pricemain}</h4>
                    <p>{SinglePricing.feetitle}</p>
                  </div>
                  <div className="pricing-content">
                    <h5 className="p-content-title">Choose Option</h5>
                    <ul className="p-content-inner">
                      <li>
                        {" "}
                        <div className="checkbox-inline">
                          <input
                            class="form-check-input"
                            type="radio"
                            name="flexRadioDefault"
                            id="flexRadioDefault1"
                          />
                          <label class="form-check-label">
                            {" "}
                            {SinglePricing.list1[0].title}
                            <span>{SinglePricing.list1[0].price}</span>
                          </label>
                        </div>
                      </li>
                      <li>
                        {" "}
                        <div className="checkbox-inline">
                          <input
                            class="form-check-input"
                            type="radio"
                            name="flexRadioDefault"
                            id="flexRadioDefault2"
                          />
                          <label class="form-check-label">
                            {SinglePricing.list2[0].title}
                            <span>{SinglePricing.list2[0].price}</span>
                          </label>
                        </div>
                      </li>
                      <li>
                        {" "}
                        <div className="checkbox-inline">
                          <input
                            class="form-check-input"
                            type="radio"
                            name="flexRadioDefault"
                            id="flexRadioDefault3"
                          />
                          <label class="form-check-label">
                            {SinglePricing.list3[0].title}
                            <span>{SinglePricing.list3[0].price}</span>
                          </label>
                        </div>
                      </li>
                      <li>
                        {" "}
                        <div className="checkbox-inline">
                          <input
                            class="form-check-input"
                            type="radio"
                            name="flexRadioDefault"
                            id="flexRadioDefault4"
                          />
                          <label class="form-check-label">
                            {SinglePricing.list4[0].title}
                            <span>{SinglePricing.list4[0].price}</span>
                          </label>
                        </div>
                      </li>
                      <li>
                        {" "}
                        <div className="checkbox-inline">
                          <input
                            class="form-check-input"
                            type="radio"
                            name="flexRadioDefault"
                            id="flexRadioDefault5"
                          />
                          <label class="form-check-label">
                            {SinglePricing.list5[0].title}
                            <span>{SinglePricing.list5[0].price}</span>
                          </label>
                        </div>
                      </li>
                      <li>
                        {" "}
                        <div className="checkbox-inline">
                          <input
                            class="form-check-input"
                            type="radio"
                            name="flexRadioDefault"
                            id="flexRadioDefault6"
                          />
                          <label class="form-check-label">
                            {SinglePricing.list6[0].title}
                            <span>{SinglePricing.list6[0].price}</span>
                          </label>
                        </div>
                      </li>
                      <li>
                        {" "}
                        <div className="checkbox-inline">
                          <input
                            class="form-check-input"
                            type="radio"
                            name="flexRadioDefault"
                            id="flexRadioDefault7"
                          />
                          <label class="form-check-label">
                            {SinglePricing.list7[0].title}
                            <span>{SinglePricing.list7[0].price}</span>
                          </label>
                        </div>
                      </li>
                      <li>
                        {" "}
                        <div className="checkbox-inline">
                          <input
                            class="form-check-input"
                            type="radio"
                            name="flexRadioDefault"
                            id="flexRadioDefault8"
                          />
                          <label class="form-check-label">
                            {SinglePricing.list8[0].title}
                            <span>{SinglePricing.list8[0].price}</span>
                          </label>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div className="pricing-btn">
                    <a href="#software-feature" className="theme-btn">
                      Software Features
                    </a>
                    <Link to="#" className="theme-btn primary">
                      Order now
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="row">
            <div className="col-12">
              <ul className="pricing-note-list">
                <li>* Each branch has separate subscription bill.</li>
                <li>* 5% VAT will be applicable on all fees and charges.</li>
                <li>* Each Add-ons has charge.</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PricingTable;
